<div class="header">
  <h2>
    {{ "pages.settings.title" | translate }}
  </h2>
</div>

<!-- Reiter wie auf „Organisation" (nb-tabset ist das Hausmuster). -->
<nb-tabset (changeTab)="onTabChange($event.tabId)">
  <nb-tab
    tabId="account"
    [active]="activeTab === 'account'"
    [tabTitle]="'pages.settings.tabs.account' | translate"
    tabIcon="person-outline"
  >
    <div class="container">
      <nb-card>
        <nb-card-header>
          <h6><nb-icon icon="person-outline"></nb-icon>{{ "pages.settings.titleDetails" | translate }}</h6>
        </nb-card-header>
        <nb-card-body>
          <app-user-details-form></app-user-details-form>
        </nb-card-body>
      </nb-card>
      <nb-card>
        <nb-card-header>
          <h6><nb-icon icon="lock-outline"></nb-icon>{{ "pages.settings.titleChangePassword" | translate }}</h6>
        </nb-card-header>
        <nb-card-body>
          <app-user-password-form></app-user-password-form>
        </nb-card-body>
      </nb-card>
      <nb-card>
        <nb-card-header>
          <h6><nb-icon icon="shield-outline"></nb-icon>{{ "pages.settings.titleTwoFactor" | translate }}</h6>
        </nb-card-header>
        <nb-card-body>
          <app-two-factor-form></app-two-factor-form>
        </nb-card-body>
      </nb-card>
    </div>
  </nb-tab>

  <!-- Nur fuer Kunden-Admins (bis zur Credit-Freigabe: super_admin). Die
       Komponente laedt erst, wenn der Reiter offen ist — `*ngIf` im Reiter,
       damit ein Nutzer ohne Recht gar keine Anfrage schickt. -->
  <nb-tab
    *ngIf="showAiLimits"
    tabId="ai"
    [active]="activeTab === 'ai'"
    [tabTitle]="'pages.settings.tabs.ai' | translate"
    tabIcon="flash-outline"
  >
    <app-credit-limits-panel *ngIf="activeTab === 'ai'"></app-credit-limits-panel>
  </nb-tab>

  <!-- Portal-Assistent: mit welchem Modell er arbeitet, und eigenen KI-Agenten
       (Claude, Cursor …) per MCP verbinden — nur wenn er für die Organisation an ist. -->
  <nb-tab
    *ngIf="agentChat.enabled()"
    tabId="agent-access"
    [active]="activeTab === 'agent-access'"
    [tabTitle]="'pages.settings.tabs.agentAccess' | translate"
    tabIcon="link-2-outline"
  >
    <ng-container *ngIf="activeTab === 'agent-access'">
      <app-agent-model-panel></app-agent-model-panel>
      <app-agent-access-panel></app-agent-access-panel>
    </ng-container>
  </nb-tab>

  <!-- Verbindungen des Creators (Figma für den Kurs-Editor) — wer den Creator hat.
       Der Editor verweist hierher („Einstellungen → Verbindungen"). -->
  <nb-tab
    *ngIf="showConnections"
    tabId="connections"
    [active]="activeTab === 'connections'"
    [tabTitle]="'pages.settings.tabs.connections' | translate"
    tabIcon="link-outline"
  >
    <app-creator-connections-panel *ngIf="activeTab === 'connections'"></app-creator-connections-panel>
  </nb-tab>
</nb-tabset>
